export const PRICING_HISTORY_TYPES = [
    { name: 'SUCCEEDED', value: 'SUCCESS', label: 'SUCCEEDED' },
    { name: 'FAILED', value: 'FAIL', label: 'FAILED' },
    { name: 'INFO', value: 'INFO', label: 'INFO' },
];